// extracted by mini-css-extract-plugin
export default {"menu":"NoteMenu_menu__hJHZs","item":"NoteMenu_item__1UoMs","danger":"NoteMenu_danger__fUsEY","icon":"NoteMenu_icon__aNtjC","divider":"NoteMenu_divider__3Mrp7"};